import { useFullStoryPageView } from 'hooks/useFullstoryPageView';
import { useLogicCheckerBreadCrumbs } from 'hooks/useLogicCheckerBreadCrumbs';

import { Breadcrumbs } from 'components/common/Breadcrumbs/Breadcrumbs';
import { GlobalFilterButton } from 'components/common/GlobalFilterButton/GlobalFilterButton';
import { GlobalFilterComponent } from 'components/common/GlobalFilterComponent/GlobalFilterComponent';
import { ActivityCodesFilter } from 'components/common/GlobalFilterComponent/components/ActivityCodesFilter/ActivityCodesFilter';
import { MilestoneFragnetFilter } from 'components/common/GlobalFilterComponent/components/MilestoneFragnetFilter/MilestoneFragnetFilter';
import { TagsFilter } from 'components/common/GlobalFilterComponent/components/TagsFilter/TagsFilter';
import { WbsFilter } from 'components/common/GlobalFilterComponent/components/WbsFilter/wbsFilter';
import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';
import { ShareInsightButton } from 'components/common/ShareInsightButton/ShareInsightButton';

import { riskConfig } from 'components/Dashboards/ExcellenceApps/riskConfig';
import { TreeProgramTopHeader } from 'components/common';
import { LogicQualityCheckActionsMenu } from 'components/widgets/LogicQualityCheckActionsMenu/LogicQualityCheckActionsMenu';
import { SummaryWrapper } from 'components/widgets/SummaryWrapper/summaryWrapper';

export const LogicQualityCheckSummaryPage = () => {
    useFullStoryPageView({ pageName: riskConfig.logicQualityCheck.title });
    const { breadcrumbs } = useLogicCheckerBreadCrumbs({ displayLevel3Activities: false });

    return (
        <PageContainer>
            <HeaderWrapper>
                <TreeProgramTopHeader>
                    <ShareInsightButton title={riskConfig.logicQualityCheck.title} link={window.location.href} />
                    <LogicQualityCheckActionsMenu />
                    <GlobalFilterButton />
                </TreeProgramTopHeader>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={riskConfig.logicQualityCheck.title} />
                    <GlobalFilterComponent
                        defaultValues={{ milestoneFragnet: null, tags: [], activityCodes: [], wbs: null }}
                    >
                        <MilestoneFragnetFilter name={'milestoneFragnet'} />
                        <TagsFilter name={'tags'} />
                        <ActivityCodesFilter name={'activityCodes'} />
                        <WbsFilter name={'wbs'} />
                    </GlobalFilterComponent>
                    <Breadcrumbs list={breadcrumbs} />
                </BottomHeaderSection>
            </HeaderWrapper>
            <MainContent>
                <SummaryWrapper />
            </MainContent>
        </PageContainer>
    );
};
